<button #subButton
[disabled]="keyboardMenuItem.disabled" 
[attr.data-button]="keyboardMenuItem.index" 
[attr.data-description]="keyboardMenuItem.description"
(click)="keyboardMenuItem.handler()"
(mouseenter)="setFocus()">{{keyboardMenuItem.label}}</button>
<app-submission-menu-subitems
*ngFor="let subItem of keyboardMenuItem.keyboardMenuSubItems"
[keyboardMenuSubitem] = "subItem"></app-submission-menu-subitems>
